import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-agents',
    templateUrl: './agents.component.html',
    styleUrls: ['./agents.component.scss'],
    standalone: false
})
export class AgentsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
